module.exports = __webpack_public_path__ + "static/media/powerSupply2.a1c8aa5b.svg";